import Http from '../../http';

export const deauthorizeInstagram = (owner, id) => Http.post('/instagram-deauth', {
  owner,
  id,
});

export const getAuthToken = (owner, id) => Http.post('/tokenize', { owner, id })
  .then(res => res.token);
